export default {
  namespaced: false,
  state: {
    /** Amount of the payment that was made */
    paymentAmount: undefined,
    /** Result of the payment that was made */
    confirmationNumber: undefined,
    /** Date for acct stoppage (not really billpay) */
    stoppageDate: undefined,
  },
  actions: {
  },
  // Changes the state
  mutations: {
    setPaymentAmount(state, amount) {
      state.paymentAmount = amount;
    },
    setConfirmationNumber(state, confirm) {
      state.confirmationNumber = confirm;
    },
    setStoppageDate(state, date) {
      state.stoppageDate = date;
    },
   clearPayment(state) {
      state.paymentAmount = undefined;
      state.confirmationNumber = undefined;
      state.stoppageDate = undefined;
    },
  },
}